/**
 * @file Footer.jsx
 * @description Site-wide footer for FinTorro, including app store links, product navigation, support, legal, and disclaimers.
 */

import React from "react";
import "../styles/homepage.css";
import appStore from "../assets/appstore-download.svg";
import playStore from "../assets/playstore-download.png";

/**
 * Footer component – responsive and brand-consistent
 *
 * @returns {JSX.Element} The site footer with links, badges, and disclaimer
 */
const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Grid layout for content blocks */}
        <div className="footer-top">
          {/* App Badges */}
          <div className="footer-section">
            <h3>Get the App</h3>
            <div className="footer-app-badges">
              <a
                href="https://apps.apple.com/us/app/fintorro-trading-lessons/id6444193731"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Download on the App Store"
              >
                <img
                  src={appStore}
                  alt="Download on the App Store"
                  className="footer-store-badge"
                />
              </a>
              <a
                href="https://play.google.com/store"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Get it on Google Play"
              >
                <img
                  src={playStore}
                  alt="Get it on Google Play"
                  className="footer-store-badge"
                />
              </a>
            </div>
          </div>

          {/* Product Links */}
          <div className="footer-section">
            <h3>Products</h3>
            <ul>
              <li><a href="/apps">Mobile Apps</a></li>
              <li><a href="/agents">Trading AI Agents</a></li>
              <li><a href="/agents">Investing AI Agents</a></li>
              <li><a href="/ask-the-chart">Ask The Chart</a></li>
              <li><a href="https://www.blog.fintorro.com/trading" target="_blank" rel="noopener noreferrer">Blog</a></li>
            </ul>
          </div>

          {/* Support Links */}
          <div className="footer-section">
            <h3>Support</h3>
            <ul>
              <li><a href="https://wa.me/message/4RKX5CK6X7AZG1" target="_blank" rel="noopener noreferrer">Contact Us</a></li>
            </ul>
          </div>

          {/* Legal Links */}
          <div className="footer-section">
            <h3>Legal</h3>
            <ul>
              <li><a href="https://www.blog.fintorro.com/privacy-policy/" target="_blank" rel="noopener noreferrer">Privacy Policy</a></li>
              <li><a href="https://www.blog.fintorro.com/terms-and-conditions/" target="_blank" rel="noopener noreferrer">Terms</a></li>
              <li><a href="https://www.blog.fintorro.com/cookie-policy/" target="_blank" rel="noopener noreferrer">Cookie Policy</a></li>
              <li><a href="https://www.blog.fintorro.com/about/" target="_blank" rel="noopener noreferrer">About Us</a></li>
            </ul>
          </div>
        </div>

        {/* Disclaimer Section */}
        <div className="footer-disclaimer">
          <h4>Disclaimer</h4>
          <p>
            <strong>Fintorro is an educational platform only.</strong> We DO NOT provide financial, investment, trading, or tax advice.
            Information is for educational purposes only and not personalized financial advice.
            <strong> Never invest more than you are willing or can afford to lose.</strong>
          </p>
        </div>

        {/* Bottom line */}
        <div className="footer-bottom">
          <p>&copy; Fintorro 2025. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;




// import React from "react";
// import "../styles/homepage.css";
// import appStore from "../assets/appstore-download.svg";
// import playStore from "../assets/playstore-download.png";

// const Footer = () => {
//   return (
//     <footer className="footer">
//       <div className="footer-container">

//         <div className="footer-top">

//           <div className="footer-section">
//             <h3>Get the App</h3>
//             <div className="footer-app-badges">
//               <a
//                 href="https://apps.apple.com/us/app/fintorro-trading-lessons/id6444193731"
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 aria-label="Download on the App Store"
//               >
//                 <img src={appStore} alt="Download on the App Store" className="footer-store-badge" />
//               </a>
//               <a
//                 href="/login"
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 aria-label="Get it on Google Play"
//               >
//                 <img src={playStore} alt="Get it on Google Play" className="footer-store-badge" />
//               </a>
//             </div>
//           </div>

//           <div className="footer-section">
//             <h3>Products</h3>
//             <ul>
//               <li><a href="https://apps.apple.com/us/app/fintorro-trading-lessons/id6444193731">Mobile Apps</a></li>
//               <li><a href="/agents">Trading AI Agents</a></li>
//               <li><a href="/agents">Investing AI Agents</a></li>
//               <li><a href="/agents">Ask The Chart</a></li>
//               <li><a href="https://www.blog.fintorro.com/trading">Blog</a></li>
//             </ul>
//           </div>

//           <div className="footer-section">
//             <h3>Support</h3>
//             <ul>
//               <li><a href="https://wa.me/message/4RKX5CK6X7AZG1">Contact Us</a></li>
//             </ul>
//           </div>

//           <div className="footer-section">
//             <h3>Legal</h3>
//             <ul>
//               <li><a href="https://www.blog.fintorro.com/privacy-policy/">Privacy Policy</a></li>
//               <li><a href="https://www.blog.fintorro.com/terms-and-conditions/">Terms and Conditions</a></li>
//               <li><a href="https://www.blog.fintorro.com/terms-and-conditions/">Cookie Policy</a></li>
//               <li><a href="https://www.blog.fintorro.com/terms-and-conditions/">About Us</a></li>
//             </ul>
//           </div>
//         </div>

//         <div className="footer-disclaimer">
//           <h4>Disclaimer</h4>
//           <p>
//             <strong>Fintorro is an educational platform only.</strong> We DO NOT provide financial, investment, trading, or tax advice.
//             Information provided is for educational purposes only and not personalized financial advice.
//             <strong> Never invest more than you are willing or can afford to lose.</strong>
//           </p>
//         </div>

//         <div className="footer-bottom">
//           <p>&copy; Fintorro 2025. All rights reserved.</p>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;
